<script setup>
import {computed, ref} from "vue";
import Gift from "./Gift.vue";

const props = defineProps({
    gifts: {
        type: Object,
        required: true,
    },
    selectedGift: {
        type: Object,
        required: false,
    },
});

const emit = defineEmits(['selected-gift']);

const congratsText = window.Drupal.t('Hooray!');
const subtitleText = window.Drupal.t('You are now eligible for a <strong>free gift!</strong>');
const showGifts = ref(true);

const buttonText = computed(() => {
    if (!showGifts.value) {
        return window.Drupal.t('Choose your gift')
    }

    return window.Drupal.t('Close')
})

const handleToggle = () => {
    showGifts.value = !showGifts.value
}

const selectGift = (gift) => {
    emit('selected-gift', gift);
}
</script>

<template>
    <div class="vue-has-gift-alert row">
        <div class="col-12">
            <div class="alert">
                <div class="d-flex align-items-center">
                    <div class="icon icon-celebration"></div>
                    <div class="alert-content">
                        <p><span class="font-weight-bold">{{ congratsText }}</span></p>
                        <p><span v-html="subtitleText"></span></p>
                    </div>
                </div>

                <div class="col-12 gift-toggle-wrapper">
                    <hr>

                    <button @click="handleToggle" :class="{'active': showGifts}">{{ buttonText }}</button>
                </div>

                <div class="col-12" v-show-slide="showGifts">
                    <div class="row mt-3">
                        <Gift
                            v-for="gift in gifts"
                            :key="gift.id"
                            :gift="gift"
                            :selected-gift="selectedGift"
                            @gift-clicked="selectGift"
                        ></Gift>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
